import { AbstractControl, ValidationErrors } from '@angular/forms';
import { BaseValidator } from '@shared/validators/base-validator';
import { BaseValidationError } from '@shared/validators/validation-error/base-error';
import { Tenant } from '@shared/models/tenant';
import { TranslationService } from '@core/translation/translation.service';

export class U2BPostcodeValidator extends BaseValidator {

    public validationError: BaseValidationError;

    private pattern: RegExp;

    constructor(public tenant: Tenant) {
        super();
        let message: string;
        switch (tenant.countryCodeISO3166) {
            case 'CH':
                message = TranslationService.translate('common.validation.postcode4');
                // Four digits, first is district, second is area, third is route, fourth is post office number.
                this.pattern = /^[1-9]\d{3}$/;
                break;
            default:
                message = TranslationService.translate('common.validation.postcode5');
                this.pattern = /^[0-9]{5}$/;
                break;
        }
        this.validationError = new BaseValidationError('pattern', message);
    }

    public validate(control: AbstractControl): ValidationErrors | null {

        // optional
        if (!control.value) {
            return this.IS_VALID;
        }

        return this.pattern.test(control.value)
            ? this.IS_VALID
            : this.IS_INVALID;
    }
}
